import * as React from 'react';
import { SearchResultPage, SearchCategory } from '../../../Model/core';
import { ResultSection, IndexTypeProps } from '.';
import { itemLength } from '../api';

export function PageResult(props: IndexTypeProps) {
    const res = props.result as SearchResultPage[];

    return (
        <ResultSection
            title='Sidor'
            cls='search-result-pages'
            items={res}
            itemsPerPage={itemLength}
            category={SearchCategory.Page}
            showMore={props.more}>

            <ul>
                {res.map(it =>
                    <li key={it.Id}>
                        <a href={it.PageLink}>
                            <strong>{it.Title}</strong>
                            <aside>{it.Desc}</aside>
                        </a>
                    </li>)}
            </ul>
        </ResultSection>
    );
}
